import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createActionNew",
    serviceName: "admin",
    query: gql`
      mutation createActionNew(
        $title: String!
        $parent_id: String
        $type: String
        $alias: String
        $color: String
        $details: String
      ) {
        createActionNew(
          title: $title
          parent_id: $parent_id
          type: $type
          alias: $alias
          color: $color
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
